module.exports = __webpack_public_path__ + "static/filters-f47f4d995f19ae6e7ddd2c922c8e5969.png";